import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import WWIPage from './pages/WWIPage';
import WWIIPage from './pages/WWIIPage';
import NapoleonicWarsPage from './pages/NapoleonicWarsPage';

const Navigation = () => {
  return (
    <nav className="bg-gray-900 text-amber-100 sticky top-0 z-50 shadow-lg border-b border-amber-700">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-2xl font-bold text-amber-400">
              ⚔️ History Vault
            </div>
          </Link>
          <div className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className="hover:text-amber-400 transition-colors font-medium"
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link 
              to="/wwi" 
              className="hover:text-amber-400 transition-colors font-medium"
              data-testid="nav-wwi"
            >
              World War I
            </Link>
            <Link 
              to="/wwii" 
              className="hover:text-amber-400 transition-colors font-medium"
              data-testid="nav-wwii"
            >
              World War II
            </Link>
            <Link 
              to="/napoleonic" 
              className="hover:text-amber-400 transition-colors font-medium"
              data-testid="nav-napoleonic"
            >
              Napoleonic Wars
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-stone-50">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/wwi" element={<WWIPage />} />
          <Route path="/wwii" element={<WWIIPage />} />
          <Route path="/napoleonic" element={<NapoleonicWarsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;